<div class="wrapper flex flex-col h-full">
  <div class="h-[24px] mb-[20px] flex flex-row justify-between items-center">
    <div></div>
    <mat-icon (click)="close()">close</mat-icon>
  </div>
  <div class="heading text-type-2 mb-[20px] flex flex-row justify-between items-center">
    <div>
      {{ reportTitle }}
    </div>
    <div class="w-[450px] flex justify-between gap-2">
      <div class="w-[400px] flex justify-end items-end gap-2">
        @for (na of nextActions; track na) {
          @for (action of na.actions; track action) {
            @if (action?.options?.styles?.color !== 'primary') {
              <div class="w-1/2">
                <app-secondary-button
                  (handleClick)="executeState(action)"
                  class="w-full workflow-btn"
                  >
                  {{ action?.options?.label === 'Submit for Approval' ? 'Submit' : action?.options?.label }}
                </app-secondary-button>
              </div>
            }
          }
          @for (action of na.actions; track action) {
            @if (action?.options?.styles?.color === 'primary') {
              <div class="w-1/2">
                <app-primary-button
                  (handleClick)="executeState(action)"
                  [color]="action?.options?.styles?.color"
                  class="w-full workflow-btn"
                  >
                  {{ action?.options?.label === 'Submit for Approval' ? 'Sign' : action?.options?.label }}
                </app-primary-button>
              </div>
            }
          }
        }
      </div>
      <div (click)="download()" class="download-btn">
        @if (isDownloading) {
          <div class="spinner">
            <mat-spinner
              class="download-spinner"
              color="primary"
              diameter="32"
              mode="indeterminate"
              strokeWidth="3"
              >
            </mat-spinner>
          </div>
        }
        @if (!isDownloading) {
          <mat-icon class="download-btn-icon ml-[2px] mt-[2px]">download</mat-icon>
        }
      </div>
    </div>

  </div>
  <div class="report flex-1 !border-[1px] !border-[#8B94B3] p-[15px]">
    <iframe
      [innerHTML]="reportHtml"
      class="preview-frame"
      id="iframe"
    ></iframe>
  </div>
</div>
